// export function horizontalScroller() {
//     const containers = document.querySelectorAll('[data-scrollable]');

//     if(containers.length < 1) return;

//     containers.forEach(container => {
//         const scrollableElement = container.querySelector('[data-scroll-list]');
//         const buttonElement = container.querySelector('[data-scroll-btn]');

//         if(!buttonElement) return;

//         const scrollableChildElement = scrollableElement.querySelector('[data-scroll-item]');
//         let scrollWidth = scrollableChildElement.offsetWidth;

//         const computedStyle = window.getComputedStyle(scrollableElement);
//         const gap = computedStyle.getPropertyValue('gap');

//         if(gap) {
//             scrollWidth += parseInt(gap.replace('px', ''));
//         }

//         buttonElement.addEventListener('click', () => {
//             scrollableElement.scrollBy({
//                 left: scrollWidth,
//                 behavior: 'smooth'
//             });
//         });
//     });
// }

export function horizontalScroller() {
  const containers = document.querySelectorAll('[data-scrollable]');

  if (containers.length < 1) return;

  containers.forEach(container => {
    const scrollableElement = container.querySelector('[data-scroll-list]');
    const buttonElement = container.querySelector('[data-scroll-btn]');

    if (!buttonElement || !scrollableElement) return;

    const scrollableChildElement = scrollableElement.querySelector('[data-scroll-item]');
    let scrollWidth = scrollableChildElement.offsetWidth;

    const computedStyle = window.getComputedStyle(scrollableElement);
    const gap = computedStyle.getPropertyValue('gap');

    if (gap) {
      scrollWidth += parseInt(gap.replace('px', ''), 10);
    }

    const updateButtonState = () => {
      const maxScrollLeft = scrollableElement.scrollWidth - scrollableElement.clientWidth;
      const isAtStart = scrollableElement.scrollLeft <= 1;
      const isAtEnd = scrollableElement.scrollLeft >= maxScrollLeft - 1;

      if (isAtEnd && !buttonElement.classList.contains('reverse')) {
        buttonElement.classList.add('reverse');
        buttonElement.setAttribute('aria-label', 'Scroll left');
      } else if (isAtStart && buttonElement.classList.contains('reverse')) {
        buttonElement.classList.remove('reverse');
        buttonElement.setAttribute('aria-label', 'Scroll right');
      }
    };

    buttonElement.addEventListener('click', () => {
      const isReversed = buttonElement.classList.contains('reverse');
      const direction = isReversed ? -1 : 1;
      scrollableElement.scrollBy({
        left: scrollWidth * direction,
        behavior: 'smooth'
      });
    });

    scrollableElement.addEventListener('scroll', updateButtonState, { passive: true });
    updateButtonState();
  });
}